module.exports = __webpack_public_path__ + "img/icon_3.0bbf2d6e.png";